import { render, staticRenderFns } from "./menu_tree.vue?vue&type=template&id=1ffc79f0&"
import script from "./menu_tree.vue?vue&type=script&lang=js&"
export * from "./menu_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports